import { socialLinks } from '@utils/agoraLinks';
import { storefrontUrl } from '@utils/storefront-url';
import { slugifyProvince } from '@utils/transformations';
import { categoryDisplayName } from '@utils/category-name';
import Link from 'next/link';
import React from 'react';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

const FALLBACK_CATEGORIES = [
  { keyword: 'Peluquería', slug: 'peluqueria' },
  { keyword: 'Barbería', slug: 'barberia' },
  { keyword: 'Centro de estética', slug: 'centro-de-estetica' },
  { keyword: 'Manicuría', slug: 'manicuria' },
  { keyword: 'Salón de belleza', slug: 'salon-de-belleza' }
];

const instagram = socialLinks.find((link) => link.name === 'Instagram');

/** Pie simple de cuatro columnas: marca, rubros, provincias y Ágora. Los enlaces a rubros y provincias
 *  son los que Google usa para llegar a esas páginas: no sacarlos. */
export default function Footer({ categories, provinces }) {
  const footerCategories = categories?.length > 0 ? categories.slice(0, 8) : FALLBACK_CATEGORIES;
  const footerProvinces = provinces?.length > 0 ? provinces.slice(0, 7) : [];

  return (
    <footer className="foot">
      <div className="foot__wrap">
        <div className="foot__brand">
          <Link href="/" className="foot__logo font-display" aria-label="Ágora, inicio">
            ágora
          </Link>
          <p className="foot__tagline">Negocios de belleza de toda la Argentina, con su trabajo y sus precios.</p>
        </div>

        <div className="foot__col">
          <h3>Categorías</h3>
          {footerCategories.map((c) => (
            <Link
              key={c.slug}
              href={`/${c.slug}`}
              onClick={() =>
                trackEvent(EVENTS.NAV_FOOTER_LINK_CLICKED, { link_type: 'category', link_name: c.keyword, link_slug: c.slug })
              }
            >
              {categoryDisplayName(c.keyword)}
            </Link>
          ))}
        </div>

        <div className="foot__col">
          <h3>Provincias</h3>
          {footerProvinces.map((p) => (
            <Link
              key={p.province}
              href={`/directorio/provincia/${slugifyProvince(p.province)}`}
              onClick={() => trackEvent(EVENTS.NAV_FOOTER_LINK_CLICKED, { link_type: 'province', link_name: p.province })}
            >
              {p.province}
            </Link>
          ))}
          <Link
            href="/directorio"
            onClick={() => trackEvent(EVENTS.NAV_FOOTER_LINK_CLICKED, { link_type: 'province', link_name: 'Todas las provincias' })}
          >
            Todas las provincias
          </Link>
        </div>

        <div className="foot__col">
          <h3>Ágora</h3>
          <a
            href={storefrontUrl('/funcionalidades', { campaign: 'footer' })}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent(EVENTS.NAV_FOOTER_LINK_CLICKED, { link_type: 'about', link_name: 'Para profesionales' })}
          >
            Para profesionales
          </a>
          {instagram && (
            <a
              href={instagram.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent(EVENTS.NAV_SOCIAL_LINK_CLICKED, { platform: instagram.name })}
            >
              Instagram
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}
